var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C3 5.44772 3.40294 5 3.9 5L20.1 5C20.5971 5 21 5.44771 21 6C21 6.55228 20.5971 7 20.1 7L3.9 7C3.40294 7 3 6.55228 3 6Z",
    fill: "#181A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12C3 11.4477 3.40294 11 3.9 11L20.1 11C20.5971 11 21 11.4477 21 12C21 12.5523 20.5971 13 20.1 13L3.9 13C3.40294 13 3 12.5523 3 12Z",
    fill: "#181A1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18C3 17.4477 3.40294 17 3.9 17L20.1 17C20.5971 17 21 17.4477 21 18C21 18.5523 20.5971 19 20.1 19L3.9 19C3.40294 19 3 18.5523 3 18Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.68bd5786fdcc23b292b46525ca71adbf.svg";
export { ForwardRef as ReactComponent };